export enum ItemStatus {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Open = 'open',
  Ended = 'ended',
}
